var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 7.03125H7.96875V4.80469C7.96875 4.74023 7.91602 4.6875 7.85156 4.6875H7.14844C7.08398 4.6875 7.03125 4.74023 7.03125 4.80469V7.03125H4.80469C4.74023 7.03125 4.6875 7.08398 4.6875 7.14844V7.85156C4.6875 7.91602 4.74023 7.96875 4.80469 7.96875H7.03125V10.1953C7.03125 10.2598 7.08398 10.3125 7.14844 10.3125H7.85156C7.91602 10.3125 7.96875 10.2598 7.96875 10.1953V7.96875H10.1953C10.2598 7.96875 10.3125 7.91602 10.3125 7.85156V7.14844C10.3125 7.08398 10.2598 7.03125 10.1953 7.03125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.9375C3.87598 0.9375 0.9375 3.87598 0.9375 7.5C0.9375 11.124 3.87598 14.0625 7.5 14.0625C11.124 14.0625 14.0625 11.124 14.0625 7.5C14.0625 3.87598 11.124 0.9375 7.5 0.9375ZM7.5 12.9492C4.49121 12.9492 2.05078 10.5088 2.05078 7.5C2.05078 4.49121 4.49121 2.05078 7.5 2.05078C10.5088 2.05078 12.9492 4.49121 12.9492 7.5C12.9492 10.5088 10.5088 12.9492 7.5 12.9492Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.0f91562664160d6ec6316cb9f69f2d57.svg";
export { ForwardRef as ReactComponent };